export default __webpack_public_path__ + "img/bf3ebf0c1a5f358b823b6ffa0c6fa7a1.svg";